import { render, staticRenderFns } from "./formDetalleCarga.vue?vue&type=template&id=ca7d4ad6&scoped=true"
import script from "./formDetalleCarga.vue?vue&type=script&lang=js"
export * from "./formDetalleCarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7d4ad6",
  null
  
)

export default component.exports